export default function useMethods(
    salon: Model.Response<Customer.Resources.Salon>
): Customer.Models.Salon.Methods {
    const photo = {
        update: getUpdatePhotoMethod(salon),
        remove: getRemovePhotoMethod(salon)
    }

    const participation = {
        store: getStoreParticipationMethod(salon),
        destroy: getDestroyParticipationMethod(salon)
    }

    const status = {
        update: getUpdateStatusMethod(salon)
    }

    const paid = getPaidMethod(salon)

    return {
        photo, 
        status, 
        participation,
        paid
    }
}

function getPaidMethod(
    salon: Model.Response<Customer.Resources.Salon>
) {
    return () => {
        salon.setData(old => {
            if (!old) return

            return { ...old, is_paid: true }
        })
    }
}

function getStoreParticipationMethod(
    salon: Model.Response<Customer.Resources.Salon>
): Customer.Models.Salon.Methods.Participation.Store {
    return (participation: Customer.Resources.Participation) => {
        salon.setData(old => {
            if (!old) return
    
            const entry = old.entry.map((section: Customer.Resources.Section) => {
                if (section.id !== participation.section_id)
                    return section
    
                section.participations.push(participation)
    
                return { ...section }
            })
    
            return { ...old, entry }
        })
    }
}

function getDestroyParticipationMethod(
    salon: Model.Response<Customer.Resources.Salon>
): Customer.Models.Salon.Methods.Participation.Destroy {
    return (participationId: number) => {
        salon.setData(old => {
            if (!old) return
    
            const entry = old.entry.map((section: Customer.Resources.PastSection | Customer.Resources.Section) => {
                const participations = section.participations.filter(participation => {
                    return participation.id !== participationId
                })
    
                return {...section, participations }
            })
    
            return { ...old, entry }
        })
    }
}

function getUpdateStatusMethod(
    salon: Model.Response<Customer.Resources.Salon>
): Customer.Models.Salon.Methods.Status.Update {
    return (status: Attributes.Salon.Status) => {
        salon.setData(old => {
            if (!old) return
            return { ...old, status }
        })
    }
}

function getRemovePhotoMethod(
    salon: Model.Response<Customer.Resources.Salon>
): Customer.Models.Salon.Methods.Photo.Remove {
    return (photoId: number) => {
        salon.setData(old => {
            if (!old) return
    
            const entry = old.entry.map((section: Customer.Resources.PastSection | Customer.Resources.Section) => {
                const participations = section.participations.filter(item => {
                    return item.photo_id !== photoId
                })
    
                return {...section, participations }
            })
    
            return { ...old, entry }
        })
    }
}

function getUpdatePhotoMethod(
    salon: Model.Response<Customer.Resources.Salon>
): Customer.Models.Salon.Methods.Photo.Update {
    return (photo: Interfaces.Photo) => {
        salon.setData(old => {
            if (!old) return 
    
            const entry = old.entry.map((section: Customer.Resources.PastSection | Customer.Resources.Section) => {
                const participations = section.participations.map((participation: Customer.Resources.Participation | Customer.Resources.PastParticipation) => {
                        if (participation.photo_id === photo.id) {
                            participation.photo = photo
                            return participation
                        }
        
                        return participation
                    })
        
                return { ...section, participations }
            })
        
            return { ...old, entry }    
        })
    }
}